module.exports = {"140727001":"昌源城区管理委员会","140727002":"丹枫城区管理委员会","140727003":"麓台城区管理委员会","140727100":"昭馀镇","140727101":"东观镇","140727102":"古县镇","140727103":"贾令镇","140727104":"城赵镇","140727105":"来远镇","140727200":"西六支乡","140727201":"峪口乡","140727400":"祁县经济开发区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140727.json
// module id = 288
// module chunks = 0